module.exports = __webpack_public_path__ + "img/tree.8854b858.png";